var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-center main-title",domProps:{"innerHTML":_vm._s(_vm.$t('title.product'))}},[_vm._v("\n    产品"),_c('em',[_vm._v("中心")]),_vm._v(" "),_c('span',[_vm._v("Products")])]),_vm._v(" "),_c('div',{staticClass:"main-content",domProps:{"innerHTML":_vm._s(_vm.contentInfo.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1904a9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/pdetail.vue
// module id = null
// module chunks = 